/**
 * Locatiile de ridicare ale vitrinei curente.
 *
 * Vitrina vine din sesiune (cea in care clientul are cosul) sau, pe o piata cu
 * un singur restaurant, din bootstrap — ca fereastra de adresa sa ofere
 * ridicarea si de pe prima pagina. Fara vitrina sau cu un core vechi, lista e
 * goala si fereastra arata doar livrarea, ca inainte.
 */

import type { PickupPointDto } from "@deliveryapp/shared";

import { fetchPickupPoints } from "../api/client";
import { useBootstrap } from "./BootstrapProvider";
import { useCart } from "./CartProvider";
import { useLoadable } from "./useLoadable";

export function usePickupStorefrontSlug(): string | null {
  const { bootstrap } = useBootstrap();
  const { session } = useCart();
  if (session.storefrontSlug !== null) return session.storefrontSlug;
  return bootstrap.storefronts.length === 1 ? (bootstrap.storefronts[0]?.slug ?? null) : null;
}

export function usePickupPoints(enabled = true): { points: PickupPointDto[]; loading: boolean; slug: string | null } {
  const { marketKey, config } = useBootstrap();
  const slug = usePickupStorefrontSlug();
  // Piata cu ridicarea oprita nu face cererea deloc.
  const active = enabled && slug !== null && config.fulfillment?.pickup === true;
  const loadable = useLoadable<PickupPointDto[]>(
    (signal) => (active && slug !== null ? fetchPickupPoints(marketKey, slug, signal) : Promise.resolve([])),
    [marketKey, slug, active],
  );
  return {
    // O eroare de retea ascunde ridicarea, nu blocheaza livrarea.
    points: loadable.data ?? [],
    loading: active && loadable.state === "loading",
    slug,
  };
}
